import { render, staticRenderFns } from "./EntertainmentTwo.vue?vue&type=template&id=2f4ebc70"
import script from "./EntertainmentTwo.vue?vue&type=script&lang=js"
export * from "./EntertainmentTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports